"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settings = exports.server = exports.log = exports.init = exports.getGlobals = exports.batch = void 0;
var _darwin = require("@kiwicom/darwin");
var _cookies = require("@kiwicom/cookies");
var session = _interopRequireWildcard(require("../session/session"));
var _session2 = require("../../consts/session");
var _Event = require("../../records/Event");
var _api = require("./api");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const staticsDefault = {
  project: "",
  module: "",
  pageName: "",
  platform: "",
  source: "",
  langId: "",
  pageViewId: "",
  ip: "",
  brandingId: "",
  bid: 0,
  device: "",
  browser: "",
  browserVersion: "",
  os: "",
  osVersion: "",
  splitster: {},
  affilParams: {},
  UTMs: {},
  features: {},
  market: "",
  language: ""
};
const data = {
  statics: staticsDefault
};
const settings = exports.settings = {
  url: "https://loglady.kiwi.com/track",
  debug: false,
  enabled: true,
  gtm: false
};
const getGlobals = function () {
  var _window$navigator, _window$navigator$con, _window$navigator2, _window$navigator2$co, _window$navigator3, _window$navigator3$co, _loadCookie, _session$load, _session$load2, _loadCookie2, _session$load3, _session$load4, _loadCookie3, _session$load5, _loadCookie4, _loadCookie5, _window$navigator4;
  let subset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    ...data.statics,
    url: window.location.href,
    domain: window.location.hostname,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    viewportWidth: window.innerWidth,
    viewportHeight: window.innerHeight,
    // 'window.navigator' has broken types, 'connection' can be not present
    /* eslint-disable @typescript-eslint/no-unnecessary-condition */
    // @ts-expect-error: outdated navigator defs
    connectionType: (_window$navigator = window.navigator) === null || _window$navigator === void 0 ? void 0 : (_window$navigator$con = _window$navigator.connection) === null || _window$navigator$con === void 0 ? void 0 : _window$navigator$con.type,
    // @ts-expect-error: outdated navigator defs
    connectionSpeed: (_window$navigator2 = window.navigator) === null || _window$navigator2 === void 0 ? void 0 : (_window$navigator2$co = _window$navigator2.connection) === null || _window$navigator2$co === void 0 ? void 0 : _window$navigator2$co.downlink,
    // @ts-expect-error: outdated navigator defs
    connectionSpeedMax: (_window$navigator3 = window.navigator) === null || _window$navigator3 === void 0 ? void 0 : (_window$navigator3$co = _window$navigator3.connection) === null || _window$navigator3$co === void 0 ? void 0 : _window$navigator3$co.downlinkMax,
    /* eslint-enable @typescript-eslint/no-unnecessary-condition */
    visitorId: (_loadCookie = (0, _cookies.load)(_cookies.Cookie.USER_ID)) !== null && _loadCookie !== void 0 ? _loadCookie : "",
    accountId: (_session$load = session.load(_session2.ACCOUNT_ID)) !== null && _session$load !== void 0 ? _session$load : "",
    email: (_session$load2 = session.load(_session2.EMAIL)) !== null && _session$load2 !== void 0 ? _session$load2 : "",
    affilId: (_loadCookie2 = (0, _cookies.load)(_cookies.Cookie.AFFILIATE_ID)) !== null && _loadCookie2 !== void 0 ? _loadCookie2 : "",
    sessionId: (_session$load3 = session.load(_session2.SESSION_ID)) !== null && _session$load3 !== void 0 ? _session$load3 : "",
    deeplinkId: (_session$load4 = session.load(_session2.DEEPLINK_ID)) !== null && _session$load4 !== void 0 ? _session$load4 : "",
    exponeaCookie: (_loadCookie3 = (0, _cookies.load)(_cookies.Cookie.EXPONEA)) !== null && _loadCookie3 !== void 0 ? _loadCookie3 : "",
    bookingSessionId: (_session$load5 = session.load(_session2.BOOKING_SESSION_ID)) !== null && _session$load5 !== void 0 ? _session$load5 : "",
    market: (_loadCookie4 = (0, _cookies.load)(_cookies.Cookie.KW_MARKET)) !== null && _loadCookie4 !== void 0 ? _loadCookie4 : "",
    language: (_loadCookie5 = (0, _cookies.load)(_cookies.Cookie.KW_LANGUAGE)) !== null && _loadCookie5 !== void 0 ? _loadCookie5 : "",
    isLoggedIn: Boolean((0, _cookies.load)(_cookies.Cookie.UA_SESSION_TOKEN)),
    isStaging: window.location.hostname.includes("fe-cloudrun.kiwi.com") || window.location.hostname.includes("fe-cloudrun.skypicker.com"),
    timestamp: new Date().toISOString(),
    abTests: (0, _darwin.loadSession)(),
    browserLang: (_window$navigator4 = window.navigator) === null || _window$navigator4 === void 0 ? void 0 : _window$navigator4.language,
    isSandbox: Boolean(session.load(_session2.IS_SANDBOX)),
    ...subset
  };
};
exports.getGlobals = getGlobals;
const getGlobalsServer = subset => ({
  ...data.statics,
  visitorId: "",
  affilId: "",
  url: "",
  domain: "",
  isStaging: Boolean(process.env.IS_STAGING),
  timestamp: new Date().toISOString(),
  ...subset
});
const init = statics => {
  // eslint-disable-next-line fp/no-mutation
  data.statics = {
    ...data.statics,
    ...statics
  };
};
exports.init = init;
const log = function (ev, props) {
  let globals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return (0, _api.api)({
    events: [(0, _Event.make)(ev, props)],
    global: getGlobals(globals)
  }, settings);
};
exports.log = log;
const server = function (ev, props) {
  let globals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return (0, _api.apiServer)({
    events: [(0, _Event.make)(ev, props)],
    global: getGlobalsServer(globals)
  }, settings);
};
exports.server = server;
const batch = function (evs) {
  let globals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _api.api)({
    events: evs,
    global: getGlobals(globals)
  }, settings);
};
exports.batch = batch;